{
  "cycle.entite.anomalies_contexte_corrections": "Corrections du contexte d’anomalies",
  "v6.anomalies.annuler_vers_fiche": "Annuler",
  "v6.anomalies.annuler_vers_liste": "Annuler",
  "v6.anomalies.anomalie_absente": "Aucune anomalie n’est désignée : ouvrez ce dialogue depuis une anomalie.",
  "v6.anomalies.champ.cible_source": "Cible de la source",
  "v6.anomalies.champ.environnement": "Environnement",
  "v6.anomalies.champ.version": "Version",
  "v6.anomalies.code.ACCESS_DENIED": "Il faut être membre actif du projet pour ce geste.",
  "v6.anomalies.code.DEFECT_SCOPE_MISMATCH": "La version, l’environnement ou le cas n’appartient pas à ce projet.",
  "v6.anomalies.code.DEFECT_STATE_CONFLICT": "L’anomalie a changé d’état ou est fermée : relisez-la avant d’agir.",
  "v6.anomalies.code.DEFECT_TRANSITION_FORBIDDEN": "Cette transition n’est pas permise depuis l’état actuel.",
  "v6.anomalies.code.DEFECT_TRIAGE_REQUIRED": "Classez d’abord l’échec : triez l’anomalie.",
  "v6.anomalies.code.DROIT_NON_TENU": "Vous ne tenez pas le droit nécessaire pour ce geste.",
  "v6.anomalies.code.NOT_FOUND": "Cette anomalie est introuvable dans ce projet.",
  "v6.anomalies.code.VALIDATION_ERROR": "Saisie refusée : vérifiez le motif et les champs choisis.",
  "v6.anomalies.code.VERSION_CONFLICT": "L’anomalie a été modifiée entre-temps : relisez-la, puis recommencez.",
  "v6.anomalies.code.WORKSPACE_ARCHIVED": "Le projet est archivé : il est en lecture seule.",
  "v6.anomalies.contexte.anomalie": "l’anomalie",
  "v6.anomalies.contexte.aucun_environnement": "Aucun environnement déclaré dans ce projet.",
  "v6.anomalies.contexte.aucune_version": "Aucune version déclarée dans ce projet.",
  "v6.anomalies.contexte.choisir": "Choisissez un environnement ou une version différents de l’actuel.",
  "v6.anomalies.contexte.correction": "{{champ}} : {{avant}} → {{apres}} — « {{motif}} » ({{auteur}})",
  "v6.anomalies.contexte.corrections": "Corrections conservées",
  "v6.anomalies.contexte.echec": "L’enregistrement du contexte n’a pas abouti.",
  "v6.anomalies.contexte.enregistre": "Contexte enregistré ; les corrections sont conservées.",
  "v6.anomalies.contexte.enregistrer": "Enregistrer le contexte",
  "v6.anomalies.contexte.environnement": "Environnement",
  "v6.anomalies.contexte.environnements": "les environnements du projet",
  "v6.anomalies.contexte.inchange": "— inchangé —",
  "v6.anomalies.contexte.manquantes": "Informations manquantes : {{liste}}.",
  "v6.anomalies.contexte.motif": "Motif de la correction",
  "v6.anomalies.contexte.motif_aide": "Obligatoire, {{n}} caractères au moins : il est conservé avec la correction.",
  "v6.anomalies.contexte.motif_requis": "Écrivez un motif de {{n}} caractères au moins.",
  "v6.anomalies.contexte.non_renseigne": "non renseigné",
  "v6.anomalies.contexte.reference": "Anomalie",
  "v6.anomalies.contexte.titre": "Compléter le contexte d’une anomalie",
  "v6.anomalies.contexte.version": "Version",
  "v6.anomalies.contexte.versions": "les versions du projet",
  "v6.anomalies.creer.attendu": "Résultat attendu",
  "v6.anomalies.creer.cas": "Cas de test d’origine (facultatif)",
  "v6.anomalies.creer.cas_aide": "Numéro du cas de ce projet.",
  "v6.anomalies.creer.cas_invalide": "Le cas d’origine est un numéro.",
  "v6.anomalies.creer.champ_titre": "Titre",
  "v6.anomalies.creer.choisir": "— choisir —",
  "v6.anomalies.creer.cible": "Cible de la source (facultatif)",
  "v6.anomalies.creer.cible_aide": "Exigence de la spécification visée, par sa référence (par exemple EXG-12).",
  "v6.anomalies.creer.cree": "Anomalie {{reference}} déclarée.",
  "v6.anomalies.creer.declarer": "Déclarer l’anomalie",
  "v6.anomalies.creer.echec": "La déclaration n’a pas abouti ; votre saisie est conservée.",
  "v6.anomalies.creer.environnement_inconnu": "Environnement inconnu, signalé comme tel",
  "v6.anomalies.creer.environnement_requis": "Choisissez l’environnement, ou signalez-le inconnu.",
  "v6.anomalies.creer.etapes": "Étapes de reproduction",
  "v6.anomalies.creer.obtenu": "Résultat obtenu",
  "v6.anomalies.creer.preuve": "Preuve (facultatif)",
  "v6.anomalies.creer.preuve_aide": "Texte, lien ou référence d’une pièce existante.",
  "v6.anomalies.creer.priorite": "Priorité",
  "v6.anomalies.creer.reproduction_requise": "Décrivez les étapes, l’attendu et l’obtenu.",
  "v6.anomalies.creer.severite": "Sévérité",
  "v6.anomalies.creer.titre": "Déclarer une anomalie",
  "v6.anomalies.creer.titre_requis": "Donnez un titre.",
  "v6.anomalies.creer.version_inconnue": "Version inconnue, signalée comme telle",
  "v6.anomalies.creer.version_requise": "Choisissez la version, ou signalez-la inconnue.",
  "v6.anomalies.doublons.aucun": "Aucun doublon possible trouvé.",
  "v6.anomalies.doublons.aucune_fusion": "Aucune fusion automatique : c’est vous qui décidez.",
  "v6.anomalies.doublons.candidat": "{{reference}} · {{titre}} ({{etat}}, ressemblance {{score}} %)",
  "v6.anomalies.doublons.ouvrir": "Ouvrir {{reference}}",
  "v6.anomalies.doublons.saisir": "Saisissez un titre pour chercher des doublons possibles.",
  "v6.anomalies.doublons.titre": "Doublons possibles",
  "v6.anomalies.echec.aucun_cas": "Aucun cas de test ne lui est rattaché définitivement.",
  "v6.anomalies.echec.aucune_fermeture": "Il ne se ferme pas par un verdict sur le produit.",
  "v6.anomalies.echec.cause": "Cause résumée",
  "v6.anomalies.echec.cause_absente": "Aucune cause écrite par la vérificatrice.",
  "v6.anomalies.echec.declare_le": "Constaté le",
  "v6.anomalies.echec.deplier": "Afficher les journaux complets",
  "v6.anomalies.echec.echec": "l’échec de mission",
  "v6.anomalies.echec.etat": "État",
  "v6.anomalies.echec.journaux": "Journaux de la mission",
  "v6.anomalies.echec.journaux_sans_mission": "Aucune mission désignée : journaux indisponibles.",
  "v6.anomalies.echec.journaux_vides": "La mission n’a laissé aucun journal.",
  "v6.anomalies.echec.mission": "mission {{mission}}",
  "v6.anomalies.echec.mission_inconnue": "mission non désignée",
  "v6.anomalies.echec.non_compte": "Un échec de mission n’est pas compté comme un défaut du produit.",
  "v6.anomalies.echec.origine": "Origine",
  "v6.anomalies.echec.pas_un_echec": "{{reference}} est une anomalie du produit, pas un échec de mission.",
  "v6.anomalies.echec.retour": "Retour aux anomalies",
  "v6.anomalies.echec.titre": "Échec de mission",
  "v6.anomalies.echec.voir_mission": "Voir la mission",
  "v6.anomalies.etat.chargement": "Chargement de {{quoi}}…",
  "v6.anomalies.etat.en_cours": "En cours…",
  "v6.anomalies.etat.erreur": "{{quoi}} : la lecture n’a pas abouti.",
  "v6.anomalies.etat.introuvable": "{{quoi}} : introuvable dans ce projet.",
  "v6.anomalies.etat.reessayer": "Réessayer",
  "v6.anomalies.etat.refus": "{{quoi}} : accès refusé.",
  "v6.anomalies.etat_anomalie.aucune_transition": "Aucune transition n’est possible depuis cet état.",
  "v6.anomalies.etat_anomalie.canonique": "Anomalie canonique",
  "v6.anomalies.etat_anomalie.canonique_aide": "L’anomalie dont celle-ci est le doublon ; jamais elle-même.",
  "v6.anomalies.etat_anomalie.canonique_requise": "Choisissez l’anomalie canonique.",
  "v6.anomalies.etat_anomalie.choisir": "Choisissez une transition.",
  "v6.anomalies.etat_anomalie.choisir_option": "— choisir —",
  "v6.anomalies.etat_anomalie.classe": "Classe d’échec",
  "v6.anomalies.etat_anomalie.classe_aide": "Obligatoire au triage : produit, test, environnement ou instable.",
  "v6.anomalies.etat_anomalie.classe_requise": "Choisissez la classe d’échec.",
  "v6.anomalies.etat_anomalie.confirmer": "Confirmer la transition",
  "v6.anomalies.etat_anomalie.correctif": "Référence du correctif",
  "v6.anomalies.etat_anomalie.correctif_aide": "SHA du commit livré (7 caractères au moins) ou identifiant de la révision qui le contient.",
  "v6.anomalies.etat_anomalie.correctif_requis": "Donnez la référence du correctif.",
  "v6.anomalies.etat_anomalie.courant": "{{reference}} · {{titre}} — état actuel : {{etat}}",
  "v6.anomalies.etat_anomalie.echec": "La transition n’a pas abouti.",
  "v6.anomalies.etat_anomalie.fait": "Transition enregistrée : l’anomalie est maintenant « {{etat}} ».",
  "v6.anomalies.etat_anomalie.ineligible": "{{action}} : impossible — {{raison}}",
  "v6.anomalies.etat_anomalie.motif": "Motif",
  "v6.anomalies.etat_anomalie.motif_requis": "Écrivez un motif de {{n}} caractères au moins.",
  "v6.anomalies.etat_anomalie.option_refusee": "{{action}} (impossible, voir la raison)",
  "v6.anomalies.etat_anomalie.titre": "Changer l’état d’une anomalie",
  "v6.anomalies.etat_anomalie.transition": "Transition",
  "v6.anomalies.qualite.actualiser": "Réessayer",
  "v6.anomalies.qualite.anciennes": "Les plus anciennes non fermées",
  "v6.anomalies.qualite.anciennes_vide": "Aucune anomalie ouverte.",
  "v6.anomalies.qualite.aucune_exclusion": "Aucune anomalie exclue.",
  "v6.anomalies.qualite.aucune_ouverte": "aucune anomalie ouverte",
  "v6.anomalies.qualite.col_anciennete": "Ancienneté",
  "v6.anomalies.qualite.col_anomalie": "Anomalie",
  "v6.anomalies.qualite.col_etat": "État et sévérité",
  "v6.anomalies.qualite.col_version": "Version",
  "v6.anomalies.qualite.comptees": "Anomalies comptées",
  "v6.anomalies.qualite.couverture": "Voir la couverture",
  "v6.anomalies.qualite.definitions": "Ce que disent les indicateurs",
  "v6.anomalies.qualite.echappement": "Anomalies trouvées en production",
  "v6.anomalies.qualite.exclusions": "Anomalies exclues des calculs",
  "v6.anomalies.qualite.indicateurs": "les indicateurs de qualité",
  "v6.anomalies.qualite.insuffisant": "Données insuffisantes",
  "v6.anomalies.qualite.jours": "{{n}} derniers jours",
  "v6.anomalies.qualite.lecon": "Leçon n° {{id}} ({{statut}}) — tirée de {{anomalie}} : {{symptome}}",
  "v6.anomalies.qualite.lecons": "Leçons",
  "v6.anomalies.qualite.lecons_vide": "Aucune leçon dans ce projet.",
  "v6.anomalies.qualite.mttr": "Délai moyen de correction",
  "v6.anomalies.qualite.mttr_detail": "sur {{n}} anomalie(s) fermée(s)",
  "v6.anomalies.qualite.ouvertes": "Ouvertes",
  "v6.anomalies.qualite.perimetre": "Anomalies du produit seulement, sur {{jours}} jours, {{version}} ; calculé le {{date}}.",
  "v6.anomalies.qualite.periode": "Période",
  "v6.anomalies.qualite.premiere_fermeture": "Le délai moyen de correction apparaîtra après la première anomalie fermée sur la période.",
  "v6.anomalies.qualite.relire_lecon": "Relire la leçon n° {{id}}",
  "v6.anomalies.qualite.reouverture": "Réouvertures",
  "v6.anomalies.qualite.sans_environnement": "{{n}} anomalie(s) sans environnement : on ne sait pas où elles ont été trouvées.",
  "v6.anomalies.qualite.sans_version": "{{n}} anomalie(s) sans version : elles ne sont rattachées à aucune version.",
  "v6.anomalies.qualite.sans_version_court": "sans version",
  "v6.anomalies.qualite.statut_lecon.dismissed": "écartée",
  "v6.anomalies.qualite.statut_lecon.proposed": "proposée",
  "v6.anomalies.qualite.statut_lecon.validated": "validée",
  "v6.anomalies.qualite.titre": "Tableau de bord qualité",
  "v6.anomalies.qualite.toutes": "Toutes",
  "v6.anomalies.qualite.toutes_versions": "toutes les versions",
  "v6.anomalies.qualite.version": "Version",
  "v6.anomalies.qualite.vide": "Aucune anomalie dans ce projet : aucun indicateur à calculer.",
  "v6.anomalies.qualite.voir_exclues": "Voir les anomalies exclues",
  "v6.anomalies.relire": "Relire l’anomalie",
  "v6.anomalies.sans_projet": "Choisissez d’abord un projet.",
  "v6.anomalies.vague_ulterieure": "« {{ecran}} » mène à un écran qui n’est pas encore réalisé : il arrive avec la vague V4.",
  "v6.anomalies.voir_fiche": "Voir la fiche de l’anomalie"
}
